import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { ArrowRight } from "lucide-react";
import { CTA_IMAGE } from "@/constants/homeContent";

export default function CtaBand() {
  return (
    <Box component="section" sx={{ position: "relative", mt: { xs: 5, md: 7 }, minHeight: { xs: 180, md: 210 }, display: "flex", alignItems: "center", overflow: "hidden" }} data-testid="cta-band">
      <Box sx={{ position: "absolute", inset: 0 }}>
        <Box component="img" src={CTA_IMAGE} alt="" sx={{ width: "100%", height: "100%", objectFit: "cover" }} />
        <Box sx={{ position: "absolute", inset: 0, bgcolor: "rgba(0,0,0,0.5)" }} />
      </Box>
      <Box sx={{ position: "relative", zIndex: 1, maxWidth: 1400, mx: "auto", width: "100%", px: { xs: 3, lg: 6 }, color: "#fff" }}>
        <Typography component="h2" className="font-serif-display" sx={{ fontSize: { xs: 22, md: 28 }, mb: 1, maxWidth: 480 }}>
          Your next escape is waiting.
        </Typography>
        <Typography sx={{ color: "rgba(255,255,255,0.85)", fontSize: { xs: 13, md: 14.5 }, mb: 2, maxWidth: 420 }}>
          Discover private villas across India's most beautiful destinations.
        </Typography>
        <Button component={Link} to="/villas" variant="contained" size="medium" endIcon={<ArrowRight size={15} />} data-testid="cta-explore-btn">
          Explore villas
        </Button>
      </Box>
      <Typography
        className="font-serif-display"
        sx={{ position: "absolute", zIndex: 1, right: { xs: 20, md: 56 }, bottom: { xs: 16, md: 24 }, color: "rgba(255,255,255,0.85)", fontStyle: "italic", fontSize: { xs: 13, md: 16 }, transform: "rotate(-4deg)", display: { xs: "none", sm: "block" } }}
      >
        Live Unfiltered
      </Typography>
    </Box>
  );
}
